export function getPreloadedState() {
    const preloadedState = window.__PRELOADED_STATE__;
    delete window.__PRELOADED_STATE__;
    return preloadedState;
}